export enum ClientProfile {
    'Médico' = 'médico',
    'Institución' = 'institución',
    Distribuidor = 'distribuidor'
}